import { union } from "../../shared/src/codecs/types/union";
import { literal } from "../../shared/src/codecs/types/literal";

export const ListingCouncilTaxBand1 = union([
    literal("unknown"),
    literal("a"),
    literal("b"),
    literal("c"),
    literal("d"),
    literal("e"),
    literal("f"),
    literal("g"),
    literal("h"),
    literal("i_wales_only"),
    literal("exempt"),
]);
